'use strict'

import angular from "angular";

import "angular-route";
import "angular-resource";

import "./Api";
import "./Token";
import "../lib/angular-foundation.min";

export default angular.module('fastx.utils', ['ngRoute','ngResource','mm.foundation','Token','fastx.Api'])
.factory('Version',['Api','$window',function(Api,$window){
	return function(cb){
		cb = cb || function(){};
		Api.get('api',{},function(d){
			$window.localStorage['version'] = d.version;
			cb(d);
		},function(e){cb(e.message);});
	};
}])
.factory('Upgrade',['Api','Token','$http','$sce',function(Api,Token,$http,$sce){
	var f = function(success,error){
		success = success || function(){};
		error 	= error || function(){};
		Api.get('/system/upgrade',{},function(d){
			$http.jsonp($sce.trustAsResourceUrl(
				'https://www.starnet.com/auto/upgrade30'
				),{
					params:d
				}).then(function(s){
					if(s.status === 200){
						if(s.data.result){
							success(s.data.result);
						}else if(s.data.error){
							error(s.data.error);
						}
					}else{
						error({
							code:s.status,
							message:s.data
						});
					}
				});
		},error);
	}
	return f;
}])
.factory('RandomString',[function(){
	return function(length) {
		var chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
		var result = '';
		for (var i = length; i > 0; --i) result += chars[Math.round(Math.random() * (chars.length - 1))];
		return result;
	}
}])
.factory('Config',['Api','Token',function(Api,Token){
	var f =  function(success,error){
		if(!Token.token){
			error({
				code:403,
				message:'Not Authorized'
			});
			return;
		}
		Api.get('api/config',{},success,error);
	};
	return f;
}])
.factory('SiteUtils',['$location','$rootScope','$modal','$window','Token',
		 function($location,$rootScope,$modal,$window,Token){
	var su = {};
		function getQueryVariable(variable)
		{
       var query = window.location.search.substring(1);
       var vars = query.split("&");
       for (var i=0;i<vars.length;i++) {
               var pair = vars[i].split("=");
               if(pair[0] == variable){return pair[1];}
       }
       return;
		}
	function errorAuthorized(e){
		if(e && e.code === 403){
			Token.remove();
			$window.localStorage.removeItem('username');
			$window.localStorage.removeItem('host');
			$location.path('login');
			return true;
		}
	}
	function errorDialog($scope,e){
		if(!errorAuthorized(e)){
			$scope.error = e;

			if(!angular.element(document.querySelector('.reveal-modal')).length){
				return $modal.open({
					templateUrl:'js/fastx/session/error-dialog.html',
					scope:$scope,
					controller:'ErrorDialogCtrl'
				});
			}
		}
	}
	su.errorAuthorized = errorAuthorized;
	su.errorDialog = errorDialog;
	su.getQueryVariable = getQueryVariable;
	return su;
}])
.controller('ErrorDialogCtrl',['$scope','$modalInstance',function($scope,$modalInstance){
	console.log($scope.$parent.error);
	$scope.error = $scope.$parent.error;
}])
.factory('WsList',['Token','$location',function(Token,$location){
	var f = {};
	var ws;
	f.create = function(uri,cb){
		cb = cb || function(){};

		if(Token.token){
			var basePath = location.href.replace(/\/[^\/]+$/,"").replace(/\/$/,"").replace(/https?:\/\//,"").replace(/#.*/g,"");
			var path = basePath + '/' +uri;
			path = path.replace(/\/+/g,'/');
			var url = [(location.protocol === 'https:')?'wss://':'ws://',path,'?token=',Token.token].join('');
			console.log('Creating Websocket',url);
			ws = new WebSocket(url);
			ws.onmessage = function(m){
				try{
					var d = JSON.parse(m.data);
					if(d.error && d.error.code === 401){//user not found
						Token.remove();
						location.reload();
					}else if(d.result){
						cb(d.result);
					}
				}catch(e){
					console.log(e);
				}

			};
			ws.onclose = function (m) {
				console.log(m);
			}
			ws.onerror = function (e) {
				console.log(e);
			}
			ws.onopen = function(){
				console.log('Websocket opened');
			}
			return 1;
		}
	}
	f.destroy = function(){
		if(ws){
			ws.close();
		}
	}
	return f;
}])

;
;



//////////////////
// WEBPACK FOOTER
// ../common/utils.js
// module id = 5
// module chunks = 0